var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { formatPhone } from '@rad/utility/formatting';
import { SITE } from '../../../utility/constants';
import { sendInspectionForReview } from '../../../http/inspections';
import CModal from '../modal';
import CErrors from '../errors';
import CSelect from '../select';
import ContactPicker from '../contact-picker';
const reifyRecipient = (contacts, whichExternal) => {
    var _a, _b, _c;
    switch (whichExternal) {
        case 'phone':
            {
                const mobile = (_a = contacts.find((x) => x.kind === 'phone' && x.subkind === 'mobile')) === null || _a === void 0 ? void 0 : _a.value;
                const unknown = (_b = contacts.find((x) => x.kind === 'phone' && x.subkind === 'unknown')) === null || _b === void 0 ? void 0 : _b.value;
                return formatPhone(mobile || unknown || '');
            }
        case 'email':
            return ((_c = contacts.find((x) => x.kind === 'email')) === null || _c === void 0 ? void 0 : _c.value) || '';
        default:
            return '';
    }
};
export default (props) => {
    var _a, _b;
    const [state, mutators] = useStateWithMutators({
        'which_external': 'phone',
        'errors': [],
        'recipient': '',
    });
    React.useEffect(() => {
        mutators.which_external('phone');
        mutators.errors([]);
        mutators.recipient(reifyRecipient(props.contacts, 'phone'));
    }, [(_a = props.inspection) === null || _a === void 0 ? void 0 : _a.id]);
    React.useEffect(() => {
        mutators.recipient(reifyRecipient(props.contacts, state.which_external));
    }, [state.which_external, (_b = props.inspection) === null || _b === void 0 ? void 0 : _b.id]);
    const previewHref = props.inspection
        ? `/external/${props.inspection.merchant_id}/${props.inspection.invoice_id}/inspection/${props.inspection.id}`
        : '';
    return _jsxs(CModal, { visible: !!props.inspection, title: `Send Inspection${props.inspection ? ` - ${props.inspection.title}` : ''}`, onClose: () => props.onClose(false), onSubmit: (complete) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const inspection = props.inspection;
                if (!inspection) {
                    complete();
                    return;
                }
                mutators.errors([]);
                if (!state.which_external) {
                    mutators.errors([{ 'field': 'recipient', 'message': 'Recipient is required' }]);
                    complete();
                    return;
                }
                let sent = false;
                yield new Promise((resolve) => {
                    sendInspectionForReview(inspection.merchant_id, inspection.invoice_id, inspection.id, state.which_external, { 'site': SITE, 'recipient': state.recipient, 'send_kind': 'update' }, {
                        'success': () => { sent = true; resolve(); },
                        'error': (res) => __awaiter(void 0, void 0, void 0, function* () {
                            try {
                                mutators.errors(yield res.json());
                            }
                            catch (_a) {
                                mutators.errors([{ 'field': '_', 'message': 'An error occured' }]);
                            }
                            resolve();
                        }),
                    });
                });
                complete();
                if (sent)
                    props.onClose(true);
            }
            catch (_a) {
                mutators.errors([{ 'field': '_', 'message': 'An error occured' }]);
                complete();
            }
        }), action: "Send", disabled: !state.recipient, children: [_jsx(CSelect, { items: [['phone', 'Text'], ['email', 'Email']], valuef: (x) => x[0], titlef: (x) => x[1], value: state.which_external, onChange: (x) => mutators.which_external((x || 'phone')), children: "Delivery Method" }), state.which_external === 'phone' && _jsxs(_Fragment, { children: [_jsx(CErrors, { errors: state.errors, mapping: { 'recipient': 'Phone' } }), _jsx(ContactPicker, { mode: "sms", contacts: props.contacts, value: state.recipient, onChange: mutators.recipient, children: "Phone" }), _jsx("div", { className: "text-center", children: _jsx("a", { target: "_blank", href: previewHref, children: "Preview Link" }) })] }), state.which_external === 'email' && _jsxs(_Fragment, { children: [_jsx(CErrors, { errors: state.errors, mapping: { 'recipient': 'Email' } }), _jsx(ContactPicker, { mode: "email", contacts: props.contacts, value: state.recipient, onChange: mutators.recipient, children: "Email" }), _jsx("div", { className: "text-center", children: _jsx("a", { target: "_blank", href: previewHref, children: "Preview Link" }) })] })] });
};
